export const filterTabs = ["综合", "好评优先", "价格低→高", "距离最近"];
export const priceRanges = ["不限", "¥500以下", "¥500-1000", "¥1000-2000", "¥2000+"];
export const hotelTypes = ["一星", "二星", "三星", "四星", "五星"];
